import React from "react";
import PropTypes from "prop-types";
import "./ReportsFormsLayout.scss";

export default function ReportsLayout({ children }) {
  return (
    <div className="proForm-layout proReportForm" style={{display:"flex",flexDirection:"column",flex:1,minHeight:0}}>
      <div className="proReportForm-contents" style={{flex:1,overflow:"auto"}}>{children}</div>
    </div>
  );
}

ReportsLayout.propTypes = {
  children: PropTypes.node.isRequired
};
